<template>
  <div class="login">
    <div class="login-wrapper">
      <div class="login-ico"></div>
      <div class="form">
        <div class="phone">
          <span>手机号</span>
          <input
            maxlength="11"
            placeholder="填写手机号"
            type="tel"
            v-model="userPhone"
          />
        </div>
        <div class="code">
          <span>验证码</span>
          <input
            @keyup.enter="login"
            maxlength="6"
            placeholder="验证码"
            type="tel"
            v-model="code"
          />
          <button
            :class="codeSended ? 'code-sended' : ''"
            @click="getCode"
            class="get-code"
          >
            {{ codeText }}
          </button>
        </div>
        <div class="functional-btn">
          <button :disabled="loginDisabled" @click="login" class="login-btn">
            登录
          </button>
          <!-- <button @click="getOauthVersion" class="oauth">云南联通用户一键登录</button> -->
        </div>
      </div>
    </div>
    <div class="home">
      <button @click="$router.push({ name: 'home' })">返回首页</button>
    </div>

    <!-- <div class="footer">
      <div class="more-rights">
        <div class="tit">更多途径享受会员权益</div>
        <div class="rights">
          <div class="rights-img">
            <img alt src="../assets/img/login/rights-icon.png" />
          </div>
          <div class="rights-intro">
            <span>办理19元移动王卡，立享会员权益</span>
            <a
              class="handle"
              href="http://eshop.nm135.cn/eshop/wap/onlineCardNew/selectMeal.do?cityId=71000130&busiType=72&sharetel=&share_agen_code=&groupChannelId=1000000002110700001"
            >点击办理</a>
          </div>
        </div>
      </div>
      <div class="privacy">
        <button @click="$router.push({name: 'privacyPolicy'})">隐私政策</button>
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import api from '../utils/api'
let flag = false
export default {
  name: 'login',
  props: {
    redirect: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      userPhone: '',
      code: '',
      codeSended: false,
      codeText: '获取验证码',
      loginDisabled: false,
      seconds: 60,
      promotionImgs: []

    }
  },
  computed: {
    ...mapState('store', [
      'channel'
    ])
  },
  created () {
    // this.getPromotionImgs()
  },
  methods: {
    ...mapActions('store', [
      'setAuthorizationHandler'
    ]),

    /**
     * 获取推广焦点图
    */
    async getPromotionImgs () {
      const data = await api.getLocationCodingHandler('login-1')
      if (data) {
        this.promotionImgs = data
      }
    },

    /**
     * 获取验证码
    */
    async getCode () {
      if (this.userPhone === '') {
        this.$toast('请输入您的手机号')
        return false
      } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.userPhone)) {
        this.$toast('请输入正确的手机号')
        return false
      } else if (this.codeSended) {
        // this.$toast('验证码已发送,请稍后...')
        return false
      }
      if (flag) {
        return false
      }
      flag = true
      const res = await this.$axios.post('/api/auth/sms', { mobile: this.userPhone })
      if (res.status === 200) {
        flag = false
        this.countDown()
        this.codeSended = true
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('验证码发送成功')
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 倒计时
    */
    countDown () {
      const timer = setInterval(() => {
        this.seconds--
        this.codeText = `(${this.seconds})s 后重新获取`
        if (this.seconds <= 0) {
          clearInterval(timer)
          this.seconds = 60
          this.codeText = '获取验证码'
          this.codeSended = false
        }
      }, 1000)
    },

    /**
     * 登录
    */
    async login () {
      if (this.userPhone === '') {
        this.$toast('手机号不能为空')
        return false
      } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.userPhone)) {
        this.$toast('请输入正确的手机号')
        return false
      } else if (this.code === '') {
        this.$toast('验证码不能为空')
        return false
      }
      if (flag) {
        return false
      }
      flag = true
      this.loginDisabled = true
      this.$toast.loading('正在登录...')
      const res = await this.$axios.post('/api/auth/login', {
        mobile: this.userPhone,
        code: this.code,
        channel: this.channel
      })
      if (res.status === 200) {
        this.$toast.clear()
        flag = false
        this.loginDisabled = false
        const { code, data, msg } = res.data
        if (code === 0) {
          await this.setAuthorizationHandler(data.token)
          this.goback()
        } else {
          this.$toast(msg)
        }
      }
    },
    goback () {
      this.redirect ? location.replace(decodeURIComponent(this.redirect)) : this.$router.back()
    },

    /**
     * 4g取号授权
    */
    async getOauthVersion () {
      const locSign = window.YDRZ.getSign(process.env.VUE_APP_APPID, 1.2)
      const sign = await this.getSignatureParams(locSign)
      await this.getSignature(sign)
    },

    /**
     * 获取签名参数
    */
    async getSignatureParams (sign) {
      this.$toast.loading({
        message: '正在获取签名,请稍后...',
        duration: 3000000,
        forbidClick: true
      })
      const res = await this.$axios.post('api/auth/sign', { sign })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          return data.sign
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     *获取签名
    */
    async getSignature (sign) {
      this.$toast.loading({
        message: '正在校验签名,请稍后...',
        duration: 3000000,
        forbidClick: true
      })
      window.YDRZ.getTokenInfo({
        data: {
          version: '1.2',
          appId: process.env.VUE_APP_APPID,
          sign: sign,
          openType: '1',
          expandParams: process.env.VUE_APP_CURRENTMODE === 'test' ? 'phoneNum=17839935680' : '',
          isTest: process.env.VUE_APP_CURRENTMODE === 'test' ? '0' : '1'
        },
        success: res => {
          // 成功回调
          this.$toast.clear()
          const channel = this.channel
          const { code, message, token, userInformation, msgId } = res
          if (code === '000000') {
            this.getTokenDetails({ token, userInformation, msgId, channel })
          } else {
            this.$toast(message)
          }
        },
        error: (error) => {
          this.$toast('本机号码一键登录失败, 请尝试验证码登录')
          return Promise.reject(error)
        }
      })
    },
    async getTokenDetails (params) {
      this.$toast.loading({
        message: '正在登录,请稍后...',
        duration: 3000000,
        forbidClick: true
      })
      const res = await this.$axios.post('api/auth/yd', params)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        // console.log(data)
        if (code === 0) {
          this.$toast('登录成功')
          await this.setAuthorizationHandler(data.token)
          this.$router.back()
        } else if (code === 9007) {
          this.$toast(msg)
        } else {
          this.$toast('本机号码一键登录失败, 请尝试验证码登录')
          // this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  .home {
    width: 100%;
    padding: 0.5rem 0;
    font-size: @fz26;
    text-align: center;
    button {
      color: #404040;
    }
  }
  .business-promotion {
    padding: 0 0.2rem;
    text-align: center;
  }
  .login-wrapper {
    width: 100%;
    height: 100%;
    background: url("../assets/img/login/login-bg.png") top no-repeat #fbfafa;
    background-size: 7.5rem 3.38rem;
    position: relative;
    .login-ico {
      position: absolute;
      top: 0.44rem;
      left: 1.76rem;
      width: 1.1rem;
      height: 0.71rem;
      background: url(../assets/img/login/login-ico.png) no-repeat;
      background-size: 100% auto;
      animation: show ease-in 1s 1;
    }
    @keyframes show {
      0% {
        transform: scale(0);
      }
      70% {
        transform: scale(120%);
      }
      85% {
        transform: scale(60%);
      }
      100% {
        transform: scale(100%);
      }
    }
    .title {
      font-size: 0.46rem;
      color: #fff;
      text-align: center;
      padding: 0.8rem 0 0.6rem;
    }
    .form {
      width: 5.7rem;
      //  height: 4.27rem;
      margin: 0 auto;
      padding-top: 4rem;
      font-size: @fz24;
      border-radius: 0.14rem;
      .phone,
      .code {
        width: 100%;
        height: 0.8rem;
        margin: 0 auto;
        margin-top: 0.4rem;
        display: flex;
        align-items: center;
        .hairline-surround(@color: #cbcbcb,@radius: 0.8rem);
        span {
          width: 1.2rem;
          font-size: @fz22;
          text-align: center;
          color: #414040;
        }
        input {
          height: 100%;
        }
      }
      .code {
        position: relative;
        .get-code,
        .code-sended {
          position: absolute;
          color: #4a90e2;
          height: 100%;
          right: 0.25rem;
        }
        .code-sended {
          color: #3498db;
        }
      }
      .functional-btn {
        padding: 0.6rem 0 0.3rem;
        .flex-column-center;
        // background-color: #fff;
        button {
          width: 100%;
          height: 0.88rem;
          font-size: @fz32;
          color: #fff;
          border-radius: 30px;
        }
        .login-btn {
          background-color: #343a4b;
        }
        .oauth {
          //  display: none;
          margin-top: 0.3rem;
          background-color: #404040;
        }
      }
    }
  }
  .footer {
    padding-top: 1.42rem;
    font-size: @fz26;
    color: @c80;
    text-align: center;
    .privacy button {
      text-decoration: underline;
    }
    .more-rights {
      .tit {
        position: relative;
        text-align: center;
        color: #ddd;
        &::before,
        &::after {
          content: "";
          position: absolute;
          width: 1.85rem;
          height: 1px;
          background-color: #ddd;
          top: 50%;
          transform: translateY(-50%);
        }
        &::before {
          left: 0.3rem;
        }
        &::after {
          right: 0.3rem;
        }
      }
      .rights {
        font-size: @fz24;
        padding: 0.38rem 0 0.75rem;
        .flex-center;
        .rights-img {
          width: 0.86rem;
          height: 0.86rem;
        }
        .rights-intro {
          height: 0.8rem;
          padding-left: 0.2rem;
          .flex-column-between;
          align-items: flex-start;
          span {
            color: @base;
          }
        }
      }
      .handle {
        color: #3498db;
      }
    }
  }
}
</style>
